'use strict';

var AbstractTableView = require('components/common/views/abstract_table_view');
var AppState = require('app_state');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');

var UserAdminView = AbstractTableView.extend({
    controller: undefined,

    events: function () {
        return _.extend({}, AbstractTableView.prototype.events, {
            'click div.js-tab-btn-transfer': 'transferPermissions',
            'click div.js-tab-btn-add-user': 'addUser',
            'click a.js-configure-user': 'configureUser',
        });
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.device = options.device;

        AbstractTableView.prototype.initialize.apply(this, [
            {
                title: i18n.TR('Nutzerverwaltung'),
                columns: [
                    { id: '#_name', name: 'Name', alwaysVisible: true }, // i18n.TR('Name')
                    { id: '#_access_rights', name: 'Zugriffsrechte' }, // i18n.TR('Zugriffsrechte')
                ],
                hasRefreshButton: true,
                hasSelectionButtons: true,
                selectionButtons: [{ ButtonText: i18n.TR('Löschen'), ButtonID: 'delete', ButtonIcon: 'fa fa-trash' }],
                customButtons: [
                    { ButtonText: i18n.TR('Rechte übertragen'), ButtonID: 'transfer' },
                    { ButtonIcon: 'fa fa-plus', ButtonID: 'add-user' },
                ],
                footNote:
                    i18n.TR('Legende') +
                    ': ' +
                    '<i class="fa fa-check text-success"></i> = ' +
                    i18n.TR('Vollzugriff') +
                    ', ' +
                    '<i class="fa fa-eye text-success"></i> = ' +
                    i18n.TR('Nur lesen'),
                context: this.device.toJSON(),
                headingID: 'userAdministration',
            },
        ]);
    },

    initializeCustomSorting: function () {
        Misc.sortTableByEmail($('th#h-Name'));
    },

    setPermission: function (permissions) {
        if (permissions.get(Consts.Permissions.AdminUser)) {
            this.initializeReadOnly();
        }
    },

    transferPermissions: function (e) {
        this.controller.showTransferUserPermissionsDialog({
            device: this.device,
            update_cb: function () {
                // force reload: update collection
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
        });
    },

    addUser: function (e) {
        this.controller.showConfigureUserDialog({
            devices: [this.device],
            permission_base: this.collection.get(AppState.user.id),
            capabilities: this.device.get('capabilities'),
            categories: [this.device.get('category')],
            update_cb: function () {
                // force reload: update collection
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
        });
    },

    configureUser: function (e) {
        e.preventDefault();
        this.controller.showConfigureUserDialog({
            model: this.collection.get(e.currentTarget.id),
            devices: [this.device],
            capabilities: this.device.get('capabilities'),
            categories: [this.device.get('category')],
            permission_base: this.collection.get(AppState.user.id),
            update_cb: function () {
                // force reload: update collection
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
        });
    },
});

module.exports = UserAdminView;
